import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PATHS } from 'src/constants/paths';
import { BULK_REPLACE_COMPONENT_INCLUDES, useGetComponent } from 'src/hooks';

import { validateComponentForBulkReplace } from '../BulkReplaceComponentPage.helper';

export const useComponentData = () => {
  const [searchParams] = useSearchParams();

  const rawComponentId = searchParams.get('componentId');
  const rawReplaceComponentId = searchParams.get('replaceComponentId');
  const componentId = rawComponentId?.replace(/[{}]/g, '') || null;
  const replaceComponentId =
    rawReplaceComponentId?.replace(/[{}]/g, '') || null;
  const navigate = useNavigate();

  const { data: originalComponent, isLoading: isLoadingOriginalComponent } =
    useGetComponent(
      componentId || '',
      undefined,
      false,
      BULK_REPLACE_COMPONENT_INCLUDES,
    );

  const {
    data: replacementComponent,
    isLoading: isLoadingReplacementComponent,
  } = useGetComponent(
    replaceComponentId || '',
    undefined,
    false,
    BULK_REPLACE_COMPONENT_INCLUDES,
  );

  useEffect(() => {
    if (
      !componentId ||
      !replaceComponentId ||
      (!isLoadingOriginalComponent &&
        !isLoadingReplacementComponent &&
        !validateComponentForBulkReplace(
          originalComponent,
          replacementComponent,
        ))
    ) {
      navigate(PATHS.COMPONENTS, { replace: true });
    }
  }, [
    componentId,
    replaceComponentId,
    originalComponent,
    replacementComponent,
    navigate,
    isLoadingOriginalComponent,
    isLoadingReplacementComponent,
  ]);

  return {
    componentId,
    replaceComponentId,
    originalComponent,
    replacementComponent,
    isLoadingOriginalComponent,
    isLoadingReplacementComponent,
    isLoading: isLoadingOriginalComponent || isLoadingReplacementComponent,
  };
};
